import cache from '@/services/cache-service';
import shippingMethodsApi from '@/services/resources/shippingMethodsApi';

export function getAll() {
    return cache.get('shipping-methods.all', () => shippingMethodsApi.getAll());
}

export default { getAll };
